export default {
  achievementLevelsBy: '{entity} por:',
  addDescriptorToAchievementLevels: 'Agregar Descriptor a {entity}:',
  percentage: 'Porcentaje',
  score: 'Puntaje',
  showDescriptors: 'Mostrar Descriptores',
  hideDescriptors: 'Ocultar Descriptores',
  achievementLevelScore: 'Puntuación del {entity}',
}
